// extracted by mini-css-extract-plugin
module.exports = {"s1wncog4":"s1wncog4"};